// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 273) return "static/chunks/273-b87d1ecd81bcee2c.js";
	if (chunkId === 523) return "static/chunks/523-afa9e5f746f4ddad.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 557 ? "f10664bc" : chunkId) + "." + {"56":"8d48e7473e275a30","557":"d468adb160e69a32","838":"764d8e22768d80f1"}[chunkId] + ".js";
};